import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSaveSearch } from '../../services/operations/ResumeAPI';
import eyeIcon from '../../../assets/icons8-eye-30.png'
import bulbIcon from "../../../assets/lightbulb_2.svg"
import '../../../styles/updateStyle.css';
import Loader from '../../Loader/Loader';
import { useNavigate } from 'react-router-dom';
import CustomPagination from '../jobPostings/CustomPagination';

const SavedSearch = () => {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    current_page: 1,
    total_page: 1,
    total: "",
    per_page: 10,
  });
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.auth.loading);
  const token = useSelector((state) => state.auth.token);
  const navigate = useNavigate();

  const getSavedSearches = async (page = 1) => {
    const result = await dispatch(getSaveSearch(token, page));
    if (result && result.data) {
      setData(result.data.data);
    }
    if (result?.data?.pagination) {
      setPagination({
        current_page: result.data.pagination.current_page,
        per_page: result.data.pagination.per_page,
        total: result.data.pagination.total,
        total_page: result.data.pagination.last_page
      });
    }
  };

  useEffect(() => {
    getSavedSearches(pagination.current_page);
  }, [pagination.current_page]);

  const formatArray = (arr) => {
    return arr && arr.length > 0 ? arr.join(', ') : '-';
  };

  const handleViewResume = (item) => {

    const dataToSend = {
      selectedFilters: item.selectedFilters,
      searchText: item.searchText,
      searchBoolean:item?.search_boolean
    };

    const base64Data = btoa(unescape(encodeURIComponent(JSON.stringify(dataToSend))));
    navigate(`/business-dashboard/resume?filters=${base64Data}`);
  };


  const handlePageChange = (newPage) => {
    if (newPage !== pagination.current_page) {
      setPagination((prev) => ({
        ...prev,
        current_page: newPage,
      }));
    }
  };

  return (
    <div className='jobpost-dashboard' style={{ minHeight: "100vh", padding: "20px", marginTop: "91px" }}>
      {loading && <Loader />}
      <h2 style={{fontWeight:"700",fontSize:"28px"}}>Saved Searches</h2>
      <div className='searches-list'>
        {
          data.length > 0 ? (
            data.map((item, index) => {
              const filters = item.selectedFilters || {};
              return (
                <div key={index} className='saved-searches-list'>
                  <div style={{display:"flex",alignItems:"flex-start",gap:"5px"}}>
                  <img src={bulbIcon} alt='bulb' className='bulb-icon' />
                  {(
                    item.searchText ||
                    item.search_boolean ||
                    filters?.location?.length ||
                    filters?.state?.length ||
                    filters?.country?.length ||
                    filters?.experience?.length ||
                    filters?.industry_name?.length ||
                    filters?.company_name?.length ||
                    filters?.skills?.length
                  ) && (
                      <p>
                        A search
                        {item.searchText && (
                          <> for <span className="keyword-skills-detail">{item.searchText}</span></>
                        )}

                        {filters.location?.length > 0 && (
                          <> with location being <span className="keyword-skills-detail">{formatArray(filters.location)}</span></>
                        )}

                        {filters.state?.length > 0 && (
                          <>
                            {(filters.location?.length > 0) ? ',' : ' with'} state being <span className="keyword-skills-detail">{formatArray(filters.state)}</span>
                          </>
                        )}

                        {filters.country?.length > 0 && (
                          <>
                            {(filters.location?.length > 0 || filters.state?.length > 0) ? ',' : ' with'} countries including <span className="keyword-skills-detail">{formatArray(filters.country)}</span>
                          </>
                        )}

                        {filters.experience?.length > 0 && (
                          <>
                            {(filters.location?.length || filters.state?.length || filters.country?.length) ? ',' : ' with'} <span className="keyword-skills-detail">{formatArray(filters.experience)}</span> years of experience
                          </>
                        )}

                        {filters.industry_name?.length > 0 && (
                          <>
                            {(filters.experience?.length || filters.country?.length || filters.state?.length) ? ',' : ' with'} industries of interest being <span className="industry-company-detail">{formatArray(filters.industry_name)}</span>
                          </>
                        )}

                        {filters.company_name?.length > 0 && (
                          <>
                            {(filters.industry_name?.length || filters.experience?.length) ? ',' : ' with'} companies targeted including <span className="industry-company-detail">{formatArray(filters.company_name)}</span>
                          </>
                        )}

                        {filters.skills?.length > 0 && (
                          <>
                            {(filters.company_name?.length || filters.industry_name?.length || filters.experience?.length) ? ', and' : ' with'} relevant skills including <span className="keyword-skills-detail">{formatArray(filters.skills)}</span>
                          </>
                        )}
                        {item.search_boolean && (
                          <> and having boolean search with  <span className="keyword-skills-detail">{item.search_boolean}</span></>
                        )}
                        .

                      </p>

                    )}
                    </div>
                  <span className="view-button"
                    onClick={() => handleViewResume(item)}>
                    <img src={eyeIcon} />
                    View
                  </span>
                </div>
              );
            })

          ) : (
            <div>
              <p className='no-saved-searches'>No saved searches found!</p>
            </div>)
        }
      </div>
      <div className='saved-searches-pagination'>
        {data?.length > 0 &&
          <CustomPagination
            totalPages={pagination.total_page}
            currentPage={pagination.current_page}
            onPageChange={handlePageChange}
          />}
      </div>
    </div>
  );
};

export default SavedSearch;
